import { v4 as uuid } from 'uuid';
import { map } from 'lodash';
import { toUUID } from '../../util/transform';
import type { ITicketHomeLoan } from './TicketHomeLoan.interface';
import TicketHomeLoanDetails from './TicketHomeLoanDetails';
import TicketHomeLoanFees from './TicketHomeLoanFees';
import TicketLoanSecuritySplit from './TicketLoanSecuritySplit';

export default class TicketHomeLoan implements ITicketHomeLoan {
  id: string;
  dealLoanSecuritySplit: Array<TicketLoanSecuritySplit>;
  details: TicketHomeLoanDetails;
  fees: TicketHomeLoanFees;

  static build = (data: ITicketHomeLoan) => new TicketHomeLoan(data);
  static blank = () => new TicketHomeLoan({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketHomeLoan} data
   */
  constructor(data?: ITicketHomeLoan) {
    this.id = toUUID(data?.id) || uuid();
    this.dealLoanSecuritySplit = map(
      data?.dealLoanSecuritySplit,
      (obj) => new TicketLoanSecuritySplit(obj, 'homeLoan')
    );
    this.details = new TicketHomeLoanDetails(data?.details);
    this.fees = new TicketHomeLoanFees(data?.fees);
  }
}
